import api from './api';

const posService = {
  // Sales Points
  getSalesPoints: (params) => api.get('/pos/api/sales-points/', { params }),
  getSalesPoint: (id) => api.get(`/pos/api/sales-points/${id}/`),
  createSalesPoint: (data) => api.post('/pos/api/sales-points/', data),
  updateSalesPoint: (id, data) => api.put(`/pos/api/sales-points/${id}/`, data),
  deleteSalesPoint: (id) => api.delete(`/pos/api/sales-points/${id}/`),

  // Cash Sales
  getCashSales: (params) => api.get('/pos/api/cash-sales/', { params }),
  getCashSale: (id) => api.get(`/pos/api/cash-sales/${id}/`),
  createCashSale: (data) => api.post('/pos/api/cash-sales/create_sale/', data),
  completeCashSale: (data) => api.post('/pos/api/cash-sales/complete_sale/', data),
  cancelCashSale: (id) => api.post(`/pos/api/cash-sales/${id}/cancel/`),
  getReceipt: (id) => api.get(`/pos/api/cash-sales/${id}/receipt/`),
  // Invoice PDF. layout: 'a4' (tax invoice) | 'thermal' (80mm till receipt).
  printCashSale: (id, layout = 'a4', download = false) =>
    api.get(`/pos/api/cash-sales/${id}/print/`, {
      params: { layout, ...(download ? { download: true } : {}) },
      responseType: 'blob',
    }),
  checkStock: (data) => api.post('/pos/api/cash-sales/check_stock/', data),
  searchProducts: (query) => api.get('/pos/api/cash-sales/search_products/', { params: { q: query } }),

  // Cashier Shifts
  getShifts: (params) => api.get('/pos/api/shifts/', { params }),
  getShift: (id) => api.get(`/pos/api/shifts/${id}/`),
  openShift: (data) => api.post('/pos/api/shifts/open_shift/', data),
  closeShift: (id, data) => api.post(`/pos/api/shifts/${id}/close_shift/`, data),
  approveVariance: (id, data) => api.post(`/pos/api/shifts/${id}/approve_variance/`, data),
  getShiftSummary: (id) => api.get(`/pos/api/shifts/${id}/summary/`),
  getActiveShift: (cashierId) => api.get('/pos/api/shifts/active_shift/', { params: { cashier: cashierId } }),

  // Daily Settlements
  getSettlements: (params) => api.get('/pos/api/settlements/', { params }),
  getSettlement: (id) => api.get(`/pos/api/settlements/${id}/`),
  createSettlement: (data) => api.post('/pos/api/settlements/create_settlement/', data),
  submitSettlementForApproval: (id) => api.post(`/pos/api/settlements/${id}/submit_for_approval/`),
  approveSettlement: (id) => api.post(`/pos/api/settlements/${id}/approve_settlement/`),
  markSettlementDeposited: (id, data) => api.post(`/pos/api/settlements/${id}/mark_deposited/`, data),
  postSettlementToGL: (id) => api.post(`/pos/api/settlements/${id}/post_to_gl/`),
  getSettlementSummary: (id) => api.get(`/pos/api/settlements/${id}/summary/`),

  // Returns
  getReturns: (params) => api.get('/pos/api/returns/', { params }),
  getReturn: (id) => api.get(`/pos/api/returns/${id}/`),
  createReturn: (data) => api.post('/pos/api/returns/create_return/', data),
  submitReturnForApproval: (id) => api.post(`/pos/api/returns/${id}/submit_for_approval/`),
  approveReturn: (id) => api.post(`/pos/api/returns/${id}/approve_return/`),
  reverseInventory: (id) => api.post(`/pos/api/returns/${id}/reverse_inventory/`),
  processRefund: (id, data) => api.post(`/pos/api/returns/${id}/process_refund/`, data),
  postReturnGLReversal: (id) => api.post(`/pos/api/returns/${id}/post_gl_reversal/`),
  getReturnSummary: (id) => api.get(`/pos/api/returns/${id}/summary/`),
};

export default posService;
